import { render, staticRenderFns } from "./FlexWrapperColSpecial.vue?vue&type=template&id=ff3f4112"
import script from "./FlexWrapperColSpecial.vue?vue&type=script&lang=js"
export * from "./FlexWrapperColSpecial.vue?vue&type=script&lang=js"
import style0 from "./FlexWrapperColSpecial.vue?vue&type=style&index=0&id=ff3f4112&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports